import { CodeNameModel } from '.';
import { Country } from '../Deal/Location/Location.types';
import { DealType, Dsp } from './Deal.types';

export type ServicesCodeNameModel = Pick<CodeNameModel, 'id' | 'code' | 'name'>;

export const NonMediaServiceStatus = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  SELECTED: 'SELECTED',
  REQUESTED: 'REQUESTED',
  REQUESTED_CANCELLATION: 'REQUESTED_CANCELLATION',
} as const;

export type Dimension = {
  type: string;
  codes: string[];
};

export type ProviderFee = {
  id: string;
  priceType: string;
  cost: number;
  currency: string;
};

export type VioohFee = {
  id: string;
  rateType: string;
  rateCost: number;
  currency: string;
};

export interface PricingConfig {
  id: string;
  serviceOwner: string;
  primary: boolean;
  overrideProviderCost: boolean;
  opsContactEmail: string;
  financeContactEmail: string;
  termAndCondition: string;
  providerFee: ProviderFee;
  vioohFee: VioohFee;
}

export interface NonMediaService {
  id: string;
  code: string;
  version: number;
  service: ServicesCodeNameModel & {
    category: ServicesCodeNameModel & {
      parent: ServicesCodeNameModel;
    };
  };
  provider: ServicesCodeNameModel;
  description: string;
  flightRequirements: number;
  impressionRequirements: number;
  playReportRequired: boolean;
  approvalRequired: boolean;
  outputFormat: string;
  outputLink: string;
  outputEstimatedDelivery: string;
  eligibilityRules: {
    id: string;
    dimensions: Dimension[];
    pricingConfigs: PricingConfig[];
  }[];
  createdAt: string;
  updatedAt: string;
  isSelected?: boolean;
}

export interface ActivatedNonMediaService {
  id: string;
  status: (typeof NonMediaServiceStatus)[keyof typeof NonMediaServiceStatus];
  measurement: NonMediaService;
  contactEmails?: string[];
  eligibilityRuleId?: string;
  pricingConfigId?: string;
  activationId?: string;
  campaignId?: string;
  dealId?: string;
  approvedAt?: string;
  approvedBy?: string;
  rejectedAt?: string;
  rejectedBy?: string;
  rejectedReason?: string;
  cancelledAt?: string;
  cancelledBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export type NonMediaServicesPayload = {
  minFlightRequirements?: number;
  minImpressionRequirements?: number;
  eligibilityRules?: {
    dimensions?: Dimension[];
  }[];
  categoryCodes?: string[];
  name?: string;
};

export type GenerateNonMediaServicesPayloadProps = {
  dealType: DealType;
  dsp: Dsp;
  country: Country;
  marketId: string;
  isReseller: boolean;
  campaignLengthInWeeks?: number;
  numberOfImpressions?: number;
  categoryFilters?: CodeNameModel[];
  servicesSearchQuery?: string;
};

export type GetSelectedNonMediaServicesPayload = {
  dealIds: string[];
  campaignIds: string[];
  activationIds: string[];
};
